// vg-binding: P7.D-134
// vg-binding: P7.D-154
//
// apps/vendor/src/pages/application/PendingReviewPage.tsx
//
// Phase 1 Wave 12 Task 99 — Vendor application post-submit page.
// Phase 7 Wave 18 Task 78 batch C6 (Amendment #1) — i18n rewrite.
// Skeleton thank-you page after Step 5 submit.

import { Link } from 'react-router-dom';
import { Button } from '@printway/ui';

import { useTranslation } from '../../lib/i18n/index.js';

export function PendingReviewPage(): JSX.Element {
  const { t } = useTranslation('onboarding');
  return (
    <main className="flex min-h-screen items-center justify-center bg-pw-surface px-6 py-12">
      <div className="w-full max-w-md rounded-2xl border border-pw-border bg-pw-bg p-8 text-center shadow-sm">
        <div className="flex justify-center">
          <div
            aria-hidden="true"
            className="flex h-20 w-20 items-center justify-center rounded-full bg-pw-primary/10 text-pw-primary"
          >
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="1.75"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="h-10 w-10"
            >
              <circle cx="12" cy="12" r="10" />
              <polyline points="12 6 12 12 16 14" />
            </svg>
          </div>
        </div>

        <h1 className="mt-6 text-2xl font-semibold tracking-tight text-pw-text">
          {t('application.pending.heading')}
        </h1>
        <p className="mt-2 text-sm text-pw-text-muted">
          {t('application.pending.descriptionPrefix')} <strong className="font-semibold text-pw-text">{t('application.pending.descriptionDays')}</strong>{' '}
          {t('application.pending.descriptionSuffix')}
        </p>

        <div className="mt-6 rounded-lg bg-pw-surface p-4 text-left">
          <p className="text-xs font-semibold uppercase tracking-wider text-pw-text-muted">
            {t('application.pending.nextHeading')}
          </p>
          <ol className="mt-2 list-decimal space-y-1 pl-5 text-sm text-pw-text">
            <li>{t('application.pending.step1')}</li>
            <li>{t('application.pending.step2')}</li>
            <li>{t('application.pending.step3')}</li>
          </ol>
        </div>

        <Link to="/login" className="mt-6 block">
          <Button type="button" className="w-full">
            {t('application.pending.returnSignIn')}
          </Button>
        </Link>
      </div>
    </main>
  );
}

export default PendingReviewPage;
